<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/es';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, DatePicker },
    data() {
        return {
            title: "Agregar Laborante digitalizador",
            items: [
                {
                text: "Laborante",
                href: "/"
                },
                {
                text: "Agregar Digitalizador",
                active: true
                }
            ],
            laborantes:[],
            laborante:'',
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            digitalizador:[
                {
                    laborante:[],
                    cantidad_encuestas:'',
                    fecha:'',
                    event:[]
                }
            ],
            laborantes_digitalizadores:[],
            eventos:[],
            liquido:0
        };
    },
    computed:{
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.laborantes_digitalizadores.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalRows() {
            return this.filteredData.length;
        },
    },
    methods:{
        labelselect_laborante ({ name }) {
            return `${name}`
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        agregar_lab_digitalizador(){
            let a={
                laborante:[],
                event:[],
                fecha:'',
                cantidad_encuestas:'',
            };
            this.digitalizador.push(a);
        },
        eliminar_digitalizador(index){
            this.digitalizador.splice(index, 1);
        },
        guardar_digitalizador(){
            if (this.digitalizador.length==0) {
                this.msg('error','No hay laborantes para agregar');
                return
            }
            //elimino los laborantes vacios
            this.digitalizador.forEach(element => {
                if(element.laborante.length==0 && element.evento_id=='' && element.fecha==''){
                    var indice = this.digitalizador.indexOf(element); // obtenemos el indice
                    this.digitalizador.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
                }
            });
            let formData = new FormData();
            formData.append('digitalizador', JSON.stringify(this.digitalizador));
            axios.post('/api/guardar_laborantes_digitalizador', formData).then(response => {
                this.laborantes_digitalizadores = response.data.digitalizador;
                this.digitalizador =[];
                if(this.digitalizador.length==0){
                    this.agregar_lab_digitalizador();
                }
                this.msg('success','Se han guardado los laborantes digitalizadores.');
            });
            
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        obtenerEvento(element){
            let evento = this.eventos.filter((ev) => ev.id==element);
            if (evento.length>0) {
                return evento[0].codigo//+'-'+evento[0].nombre_difusion;
            }
        },
        valorpago(lab){
            axios.get('/api/get_pagos_periodo/'+lab.id).then(response => {
                this.liquido = response.data.total_liquido
                if (this.liquido>=250000) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'warning',
                        title: 'Laborante alcanzó limite de $250.000 en periodo '+this.formatFecha(response.data.inicio)+' al '+this.formatFecha(response.data.fin) ,
                        text: 'Tener en consideración para próximas actividades.',
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#C87838"
                        //showConfirmButton: false,
                        //timer: 5000
                    });
                }
            });
        }
    },
    mounted(){
        axios.get('/api/get_laborantes').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes= response.data.usuarios;
            }else {
                this.laborantes= response.data.usuarios.filter((us) => us.sede==this.user.sede);
            }
        });
        axios.get('/api/get_laborantes_digitalizador').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes_digitalizadores= response.data.digitalizador;
            }else if(this.user.rol=='Supervisor'){
                this.laborantes_digitalizadores= response.data.digitalizador.filter((us) => us.sede==this.user.sede);
            }else if(this.user.rol=='Coordinador'){
                this.laborantes_digitalizadores= response.data.digitalizador.filter((us) => us.user_id==this.user.id);
            }
        });
        axios.get('/api/get_eventos').then(response => {
            this.eventos= response.data.eventos;
        });
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="offset-md-1 col-md-10">
                                <h5 class="text-primary mb-4">Agregar Laborantes Digitalizador: </h5>
                                <div class="row mb-3 pb-2 shadow-sm" v-for="(lab,index) in digitalizador" :key="index">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Laborante:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes" 
                                                    placeholder="Seleccionar laborante" 
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    @select="valorpago"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Evento:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <multiselect
                                                    v-model="lab.event"
                                                    :options="eventos" 
                                                    placeholder="Seleccionar evento" 
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelEvento"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Fecha:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Cantidad de encuestas:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <input type="number" id="direccion" v-model="lab.cantidad_encuestas" class="form-control border-primary">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="offset-md-11 col-md-1">
                                        <b-button variant="danger" class="mt-2" @click="eliminar_digitalizador(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3 text-right">
                                        <b-button class="" variant="primary" @click="agregar_lab_digitalizador"><i class="bx bx-plus"></i>Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button variant="primary" block @click="guardar_digitalizador()">Guardar Laborantes Digitalizadores</b-button>
                                        <!-- <p class="text-primary mt-2">(**) Los laborantes permaneceran editables mientras no se paguen. Una vez se paguen, pasarán al listado de abajo.</p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 30%;">Nombre</th>
                                        <th style="width: 10%;">RUT</th>
                                        <th style="width: 10%;">Sede</th>
                                        <th style="width: 10%;">Fecha</th>
                                        <th style="width: 10%;">Nº encuestas</th>
                                        <th style="width: 10%;">Evento</th>
                                        <!-- <th style="width: 20%;">Acción</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ item.sede }}</td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.cantidad_encuestas }}</td>
                                        <td>{{ obtenerEvento(item.evento_id) }}</td>
                                        <!-- <td>
                                            
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>